const routes = {
    Homepage: '/',
    TERMS_CONDITIONS: '/TermsConditions',
    PRIVACY_POLICY: '/PrivacyPolicy',
  
}
export default routes;